import useInView from '../../hooks/useInView.js';

/**
 * Wraps children in a scroll-reveal container.
 * `as` controls the rendered tag. `delay` is in ms (stagger).
 * `className` is applied to the wrapper.
 */
export default function SectionReveal({
  as: Tag = 'div',
  delay = 0,
  className = '',
  children,
  ...rest
}) {
  const [ref, inView] = useInView();
  return (
    <Tag
      ref={ref}
      className={`reveal ${inView ? 'is-visible' : ''} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
      {...rest}
    >
      {children}
    </Tag>
  );
}
